<template>
  <div :id="'delivery-accessorials' + tripNumber" class="card-accessorials">
    <div
      v-for="(accessorial, index) in accessorialsDelivery"
      v-bind:key="accessorial.id"
    >
      <b-form-checkbox
        v-model="selectedAccessorialsDelivery[index]"
        value="accepted"
        unchecked-value="not_accepted"
        size="sm"
        @input="selectAccessorial(accessorial, index)"
        class="checkbox-group__checkbox"
      >
        {{ accessorial.accessorial }}
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "AccessorialsDelivery",
  props: {
    tripNumber: Number
  },
  data() {
    return {
      selectedAccessorialsDelivery: [],
      accessorialsDelivery: [],
      user: null,
      newTab: null,
      currentDepartment: null,
      selectedMode: null
    };
  },
  watch: {
    newTab() {
      this.setAccessorialsListNewTab();
    },
    selectedAccessorialsDelivery() {
      return this.$emit("input", this.selectedAccessorialsDelivery);
    },
    accessorials() {
      this.setAccessorialsList();
    },
    showSelectedMode(value) {
      this.selectedMode = value;
    }
  },
  computed: {
    ...mapState({
      accessorials: state => state.quotes.accessorials.accessorials
    }),
    ...mapGetters("quotes/quote", ["showSelectedMode"])
  },
  mounted() {
    this.currentDepartment = JSON.parse(
      localStorage.getItem("current-department")
    );
    this.newTab = this.tripNumber;
    let userAux = localStorage.getItem("charlie-username-otr");
    this.user = JSON.parse(userAux);
    /* Tener en cuenta si se debe activar o en próximo PR se borra
    if (this.user[0].rol.name == "superuser") {
      document.getElementById(
        `accessorials` + this.tripNumber
      ).style.pointerEvents = "none";
    } */
    this.setAccessorialsList();
    return this.$emit("input", this.selectedAccessorialsDelivery);
  },
  methods: {
    setAccessorialsListNewTab() {
      let response = this.$store.getters[
        "quotes/accessorials/showAccessorials"
      ];
      if (response && response !== null) {
        this.accessorialsDelivery = response.filter(
          el => el.accessorial_type === "delivery"
        );
      }
    },
    setAccessorialsList() {
      let response = this.$store.getters[
        "quotes/accessorials/showAccessorials"
      ];
      if (response) {
        this.accessorialsDelivery = response.filter(
          el => el.accessorial_type === "delivery"
        );
      }
      let accessorialsHaul = this.$store.getters["quotes/quote/showQuoteById"]
        .haul[this.tripNumber - 1].accessorial;
      for (let accessorial of accessorialsHaul) {
        for (let i in this.accessorialsDelivery) {
          if (
            accessorial.accessorial.accessorial_type == "delivery" &&
            accessorial.accessorial.name ==
              this.accessorialsDelivery[i].accessorial
          ) {
            this.selectedAccessorialsDelivery[i] = "accepted";
          }
        }
      }
    },
    async selectAccessorial(accessorial, index) {
      let info = {
        body: {},
        params: null
      };
      info.body.haul_ = this.$store.getters["quotes/quote/showQuoteById"].haul[
        this.tripNumber - 1
      ].id;
      info.body.accessorial_ = accessorial.id;
      info.params = this.selectedMode ?? this.showSelectedMode;
      if (this.selectedAccessorialsDelivery[index] == "accepted") {
        await this.$store.dispatch(
          "quotes/accessorials/checkAccessorial",
          info
        );
        let quoteId = this.$route.params.id;
        await this.$store.dispatch("quotes/quote/getQuote", quoteId);
      } else if (this.selectedAccessorialsDelivery[index] == "not_accepted") {
        await this.$store.dispatch(
          "quotes/accessorials/uncheckAccessorial",
          info
        );
        let quoteId = this.$route.params.id;
        await this.$store.dispatch("quotes/quote/getQuote", quoteId);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card-accessorials {
  height: 100%;
  @include flex-wrap(center);
  flex-direction: row;
}

.checkbox-group {
  &__checkbox {
    text-transform: capitalize;
    margin: 2px 10px !important;
    font-size: 13px !important;
  }
}
</style>
